import { UserButton } from "@clerk/clerk-react";
import { ThemeToggle } from "@/components/theme-toggle";
import { Bell, Menu } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useUserRole } from "@/lib/hooks/use-user-role";
import { useGlobalStore } from "@/lib/store";
import { useMediaQuery } from "@/lib/hooks/use-media-query";

export function Header() {
  const { data: userRole } = useUserRole();
  const isAuthor = userRole?.isAuthor || false;
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const { sidebarOpen, setSidebarOpen } = useGlobalStore();

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="h-16 border-b border-border px-4 md:px-6 flex items-center justify-between bg-background/95 backdrop-blur-sm sticky top-0 z-40"
    >
      <div className="flex items-center gap-4">
        {isMobile && !sidebarOpen && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden"
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}
        <h1 className="text-lg md:text-xl font-semibold text-foreground">
          {isAuthor ? "Author Dashboard" : "Admin Dashboard"}
        </h1>
      </div>
      <div className="flex items-center gap-2 md:gap-4">
        <ThemeToggle />
        {/* <Button variant="ghost" size="icon" className="text-foreground hover:text-foreground-subtle hover:bg-background-subtle">
          <Bell className="h-5 w-5" />
        </Button> */}
        <UserButton
          afterSignOutUrl="/"
          appearance={{
            elements: {
              avatarBox: "h-8 w-8",
              rootBox: "h-8",
              userButton: "text-foreground hover:text-muted-foreground",
              userButtonPopover: "bg-background border border-border shadow-md",
              userButtonPopoverHeader: "bg-muted border-b border-border",
              userButtonPopoverHeaderTitle: "text-foreground font-semibold",
              userButtonPopoverContent: "text-foreground",
              userButtonPopoverHeaderSubtitle: "text-muted-foreground",
              userPreviewMainIdentifier: "text-foreground",
              userPreviewSecondaryIdentifier: "text-muted-foreground",
              userPreviewTextContainer: "gap-0.5",
              userButtonPopoverCard: "bg-background border border-border shadow-md",
              userButtonPopoverActions: "text-foreground",
              userButtonPopoverActionButtonText: "text-foreground",
              userButtonPopoverActionButton: "text-foreground hover:bg-muted hover:text-foreground",
              userButtonPopoverFooter: "hidden",
              pageScrollBox: "bg-background border border-border",
              clerkBranding: "hidden",
            },
          }}
        />
      </div>
    </motion.header>
  );
}